import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import { toast } from "react-toastify";
import EditDocType from "./EditDocTypes";
import { addDocType } from "services/docTypeService";
import DocTypeList from "./DocTypesList";

const DocTypes = () => {
  const [addNewForm, setAddNewForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    const result = await addDocType({
      active: true,
      ...data,
    });
    setIsSubmitting(false);

    if (result.success) {
      toast.success("Document Type Added");
      setAddNewForm(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setAddNewForm(true);
            }}
          >
            Add <br></br>
            Document Type
          </Button>
        </div>
        <div className={`row mx-auto mt-3 col-12 col-xl-9 col-xxl-5`}>
          <DocTypeList />
        </div>
      </>
      {addNewForm && (
        <EditDocType
          type="addNew"
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
          cancelEdit={() => setAddNewForm(false)}
        />
      )}
    </React.Fragment>
  );
};

export default DocTypes;
